module.exports = __webpack_public_path__ + "static/media/Family.12e02434.jpg";